// Module
var code = "<span class=\"gslb-replication-status\" ng-mouseover=\"$ctrl.onHover($event)\" ng-mouseleave=\"$ctrl.onLeave()\"> <cds-icon class=\"gslb-replication-status__state-icon gslb-replication-status__state-icon--error\" shape=\"exclamation-triangle\" size=\"20\" ng-if=\"$ctrl.displayIcon()\"></cds-icon> {{ $ctrl.row.replicationSyncState }} </span> ";
// Exports
export default code;